
import moment from 'moment'
import StreetData from './StreetData'
import TypeData from './TypeData'
import WardData from './WardData'
import DirectionData from'./DirectionData'
import StructureData from './StructureData'
import LandUsageTypeData from './LandUsageTypeData'
import LineTypeData from './LineTypeData'

var table = {
    name: 'realestate.online_scan',
    list_views: {
        filters: [
            {
                col: 'ward',
                type: 'select',
                value: null,
            },
            {
                col: 'street',
                type: 'text',
                value: null,
            },
            {
                col: 'area',
                type: 'number',
                from: null,
                to: null
            },
            {
                col: 'price',
                type: 'number',
                from: null,
                to: null
            },
            {
                col: 'type',
                type: 'select',
                value: null
            },
            {
                col: 'structure',
                type: 'select',
                value: null
            },
            {
                col: 'direction',
                type: 'multi-select',
                options: [
                    {
                        value: 'Đông',
                        label: 'Đông',
                    },
                    {
                        value: 'Đông Bắc',
                        label: 'Đông Bắc',
                    },
                    {
                        value: 'Đông Nam',
                        label: 'Đông Nam',
                    },
                    {
                        value: 'Tây',
                        label: 'Tây',
                    },
                    {
                        value: 'Tây Bắc',
                        label: 'Tây Bắc',
                    },
                    {
                        value: 'Tây Nam',
                        label: 'Tây Nam',
                    },
                    {
                        value: 'Nam',
                        label: 'Nam',
                    },
                    {
                        value: 'Bắc',
                        label: 'Bắc',
                    },
                    {
                        value: '',
                        label: 'Không có hướng',
                    }
                ],
                value: null
            },
            {
                col: 'lineType',
                type: 'select',
                value: null
            },
            {
                col: 'isAuto',
                value: null,
                type: 'multi-select',
                options: [
                    {
                        value: 1,
                        label: 'Tự động',
                    },
                    {
                        value: 0,
                        label: 'Thủ công',
                    }
                ]
            },
            {
                col: 'rent',
                type: 'boolean',
                value: false
            },
            {
                col: 'trait',
                type: 'text',
                value: null,
            },
            {
                col: 'address',
                type: 'text',
                value: null,
            }
        ],
        sorts: {
            date: 'desc',
            area: 'desc',
            price: 'desc'
        },
        columns: [
            {
                key: 'id',
                variant: 'warning'
            },
            'date',
            'fullname',
            'street',
            'address',
            // 'gps',
            'price',
            'pricePerArea',
            // 'notes',
            'area',
            'areaWidth',
            'areaLength',
            'trait',
            // 'type',
            'structure',
            // 'direction'
        ]
    },
    input_view: {
        forms: [
            {
                col: 'date',
                type: 'date',
                value: null,
                defaultValue: moment().format('yyyy-MM-DD'), // default value
                required: false,
                visible: true, // this is generated automatically, we don't need to show to user
                colspan: 4
            },
            {
                col: 'fullname',
                type: 'text',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 4
            },
            {
                col: 'type',
                type: 'multi-select',
                value: null, // default value
                defaultValue: 'Môi giới',
                required: false,
                visible: true,
                colspan: 4
            },
            {
                col: 'ward',
                type: 'select',
                value: null, // default value
                required: false,
                visible: true,
                colspan:2,
                onInit: (formField, forms) => {
                    // we'll filter the street based on the value of this field
                    // if there is no value in this ward input, we'll leave the value as default
                    //
                    if(!formField.value) {
                        return;
                    }

                    
                    var newOptions = [];

                    for(var j=0; j<StreetData.street.length; j++) {
                        console.log(StreetData.street[j].ward + ' vs ' + formField.value);
                        if(StreetData.street[j].ward == formField.value) {
                            newOptions.push(StreetData.street[j]);
                        }
                    }
                     
                    for(var i=0; i<forms.length; i++) {
                        if(forms[i].col === 'street') {
                            forms[i].options = newOptions;
                        }
                    }
                },
                change: (evt, forms) => {
                    // console.log('ward changed ', evt)
                    // console.log(typeof evt);
                    var newOptions = [];

                    for(var j=0; j<StreetData.street.length; j++) {
                        // console.log(StreetData.street[j].ward + ' vs ' + evt);
                        if(StreetData.street[j].ward == evt) {
                            newOptions.push(StreetData.street[j]);
                        }
                    }
                     
                    for(var i=0; i<forms.length; i++) {
                        if(forms[i].col === 'street') {
                            forms[i].options = newOptions;
                        }
                    }
                    
                    // console.log('new options: ', newOptions);
                }
            },
            {
                col: 'street_code',
                type: 'text',
                value: null, // default value
                required: false,
                visible: true,
                disabled: true,
                colspan:2,
            },
            {
                col: 'street',
                type: 'typeahead',
                defaultValue: '',
                value: '', // default value
                required: false,
                visible: true,
                colspan:8,

                options: StreetData.street,
                optionSerializer: opt => (opt.ward + ' > ' + opt.street + ' > ' + opt.street_2),
                optionLabel: opt => (opt.ward + ' > ' + opt.street + ' > ' + opt.street_2),
                optionValueName: 'code', // name of the attribute which will be stored inside the database
                hitFunction: (evt, forms, input) => {
                    for(var i=0; i<forms.length; i++) {
                        if(forms[i].col === 'street_code') {
                            forms[i].value = evt.code;
                        }
                    }
                }
            },

            {
                col: 'line',
                type: 'number',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 4
            },

            {
                col: 'lineType',
                type: 'select',
                value: null, // default value
                defaultValue: 'Mặt tiền',
                required: false,
                visible: true,
                colspan: 4,
                hint: 'Mặt tiền (đường ôtô, có vỉa hè). Hẻm ôtô (>3m, không có vỉa hè). Hẻm xe máy (<3m)'
            },
            {
                col: 'corner',
                type: 'checkbox',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 2
            },
            {
                col: 'rent',
                type: 'checkbox',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 2
            },
            {
                col: 'address',
                type: 'textarea',
                value: null, // default value
                hint: 'Ghi rõ vị trí cụ thể và hướng dẫn đường đi tới BĐS',
                required: false,
                visible: true,
                colspan: 8
            },

            // {
            //     col: 'gps',
            //     type: 'text',
            //     value: null, // default value
            //     required: false,
            //     visible: true,
            //     colspan: 3
            // },


            {
                col: 'splitter_1',
                type: 'line',
                value: null, // default value
                required: false,
                visible: true,
                colspan:12
            },

            {
                col: 'area',
                type: 'number',
                value: null, // default value
                required: false,
                visible: true,
                colspan:2
            },
            {
                col: 'areaWidth',
                type: 'number',
                value: null, // default value
                required: false,
                visible: true,
                colspan:2
            },
            {
                col: 'areaLength',
                type: 'number',
                value: null, // default value
                required: false,
                visible: true,
                colspan:2
            },
            {
                col: 'quantity',
                type: 'number',
                value: 1, // default value
                defaultValue: 1,
                required: false,
                visible: true,
                colspan: 2
            },
            {
                col: 'usageType',
                type: 'multi-select',
                value: null, // default value
                defaultValue: 'ODT',
                required: false,
                visible: true,
                colspan: 4
            },
            

            {
                col: 'houseArea',
                type: 'number',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 2
            },
            {
                col: 'houseAreaWidth',
                type: 'number',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 2
            },
            {
                col: 'houseAreaLength',
                type: 'number',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 2
            },

            
            {
                col: 'houseUsageArea',
                type: 'number',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 2
            },
            {
                col: 'direction',
                type: 'multi-select',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 4
            },
            {
                col: 'structure',
                type: 'multi-select',
                value: null, // default value
                defaultValue: 'Đất trống',
                required: false,
                visible: true,
                colspan: 4
            },

            {
                col: 'land_no',
                type: 'text',
                value: null, // default value
                defaultValue: '',
                required: false,
                visible: true,
                colspan: 2
            },


            {
                col: 'land_map_no',
                type: 'text',
                value: null, // default value
                defaultValue: '',
                required: false,
                visible: true,
                colspan: 2
            },
            
            {
                col: 'price',
                type: 'number',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 2,
                validationFunc: (inputObj) => {
                    if(inputObj.value) {
                        var val = parseFloat(inputObj.value);
                        if(isNaN(val)) {
                            inputObj.error = "Định dạng số chưa đúng, vui lòng dùng '.' cho phần thập phân.";
                            return false;
                        }
                    }
                    
                    return true;
                }
            },
            
            {
                col: 'pricePerArea',
                type: 'number',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 2
            },

            {
                col: 'splitter_3',
                type: 'line',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 12
            },

            {
                col: 'positive',
                type: 'textarea',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 6
            },
            {
                col: 'trait',
                type: 'textarea',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 6
            },
            // {
            //     col: 'notes',
            //     type: 'textarea',
            //     value: null, // default value
            //     required: false,
            //     visible: true,
            //     colspan: 6
            // },
            // {
            //     col: 'priceForRent',
            //     type: 'number',
            //     value: null, // default value
            //     required: false,
            //     visible: true,
            //     colspan: 4
            // },
            {
                col: 'phone',
                type: 'text',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 4
            },
            {
                col: 'link',
                type: 'link',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 4
            },
            {
                col: 'image_list',
                type: 'image_list',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 12
            },
        ]},
    columns: {
        id: {
            'name': 'id',
            'type': 'id',
            'alias': 'ID'
        },
        date: {
            'name': 'date',
            'type': 'date',
            'alias': 'Ngày tháng',
            formatter: function(value) {
                return moment(value).format('DD/MM/YYYY')
            }
        },
        fullname: {
            'name': 'fullname',
            'type': 'text',
            'alias': 'Họ tên',
        },
        type: {
            'name': 'type',
            'type': 'text',
            'alias': 'Người rao bán',

            options: TypeData.data
        },
        ward: {
            'name': 'ward',
            'type': 'text',
            'alias': 'Phường',
            
            options: WardData.data
        },
        street_code: {
            'name': 'street_code',
            'type': 'text',
            'alias': 'Mã đường',

        },
        street: {
            'name': 'street',
            'type': 'text',
            'alias': 'Tên đường',
        },
        address: {
            'name': 'address',
            'type': 'text',
            'alias': 'Địa chỉ',
        },
        price: {
            'name': 'price',
            'type': 'number',
            'alias': 'Giá'
        },
        pricePerArea: {
            'name': 'pricePerArea',
            'type': 'number',
            'alias': 'Giá theo m2'
        },
        area: {
            'name': 'area',
            'type': 'number',
            'alias': 'Diện tích đất (m2)'
        },
        areaWidth: {
            'name': 'areaWidth',
            'type': 'number',
            'alias': 'Đất ngang (m)'
        },
        areaLength: {
            'name': 'areaLength',
            'type': 'number',
            'alias': 'Đất dài (m)'
        },
        structure: {
            'name': 'structure',
            'type': 'text',
            'alias': 'Kết cấu',
            options: StructureData.data
        },
        land_no: {
            'name': 'land_no',
            'type': 'text',
            'alias': 'Số thửa'
        },
        land_map_no: {
            'name': 'land_map_no',
            'type': 'text',
            'alias': 'Số tờ'
        },
        direction: {
            'name': 'direction',
            'type': 'text',
            'alias': 'Hướng',
            options: DirectionData.data
        },
        positive: {
            'name': 'positive',
            'type': 'text',
            'alias': 'Ưu điểm'
        },
        trait: {
            'name': 'trait',
            'type': 'text',
            'alias': 'Đặc điểm'
        },
        quantity: {
            'name': 'quantity',
            'type': 'number',
            'alias': 'Số lô'
        },
        usageType: {
            'name': 'usageType',
            'type': 'text',
            'alias': 'Loại đất',
            options: LandUsageTypeData.data
        },
        line: {
            'name': 'line',
            'type': 'number',
            'alias': 'Lòng đường'
        },
        lineType: {
            'name': 'lineType',
            'type': 'text',
            'alias': 'Loại đường',
            options: LineTypeData.data
            
        },
        houseArea: {
            'name': 'houseArea',
            'type': 'number',
            'alias': 'Diện tích nhà (m2)',
        },
        houseAreaWidth: {
            'name': 'houseAreaWidth',
            'type': 'number',
            'alias': 'Nhà ngang',
        },
        houseAreaLength: {
            'name': 'houseAreaLength',
            'type': 'number',
            'alias': 'Nhà dài',
        },
        houseUsageArea: {
            'name': 'houseUsageArea',
            'type': 'number',
            'alias': 'Diện tích sàn (m2)',
        },
        corner: {
            'name': 'corner',
            'type': 'text',
            'alias': 'Nền góc',
        },
        rent: {
            'name': 'rent',
            'type': 'text',
            'alias': 'Cho Thuê',
        },
        isAuto: {
            'name': 'isAuto',
            'type': 'text',
            'alias': 'Quét tự động',
        },
        phone: {
            'name': 'phone',
            'type': 'text',
            'alias': 'Số điện thoại',
        },
        link: {
            'name': 'link',
            'type': 'text',
            'alias': 'Link'
        },
        image_list: {
            'name': 'image_list',
            'type': 'json',
            'alias': 'Hình ảnh'
        },
        product_id: {
            'name': 'product_id',
            'type': 'number',
            'alias': ''
        },
    }
}

export default {
    table_name: table.name,
    filter_orders: table.filter_orders,
    list_views: table.list_views,
    input_view: table.input_view,
    columns: table.columns
}